query MobileScansScreenshots($runId: ConditionID!) {
	issues(run_id_eq: $runId, deleted_eq: { value: false }) {
		scan_id
		screenshot
	}
}
